import { icons as generatedIcons } from "./generated/index.ts";
import type { IconComponent } from "./icon-types.ts";
import { GoogleCalendarLogo } from "./manual/google-calendar-logo.tsx";
import { GoogleLogo } from "./manual/google-logo.tsx";
import { MicrosoftOutlookLogo } from "./manual/microsoft-outlook-logo.tsx";
import { type IconName } from "./names.ts";

export const ICON_REGISTRY = {
  ...generatedIcons,
  google: GoogleLogo,
  "google-calendar": GoogleCalendarLogo,
  "microsoft-outlook": MicrosoftOutlookLogo,
} satisfies Record<IconName, IconComponent>;

export {
  ICON_COUNT,
  ICON_NAMES,
  isIconName,
  toIconName,
} from "./names.ts";
export type { IconComponent, IconComponentProps } from "./icon-types.ts";
export type { IconName } from "./names.ts";

export {
  PICKER_ICON_GROUPS,
  PICKER_ICON_NAMES,
  PICKER_ICON_REGISTRY,
  isGlyphName,
  isPickerIconName,
  pickerIconLabel,
  toGlyphName,
  toPickerIconName,
} from "./picker/index.ts";
export type { GlyphName, PickerIconName } from "./picker/index.ts";
